<template>
  <div>
    <component v-if="currentComponent" :is="currentComponent"></component>
    <router-view :key='$route.path' v-else />
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  computed: {
    currentComponent () {
      const route = this.$route;
      console.log('route', route);
      if (route.meta.isMultistage) {
        return route.meta.currentComponent;
      }
      return false;
    }
  },
  methods: {},
  created() {
    console.log('this.Rroute', this.$route);
  }
};
</script>
